import { FC, useCallback } from 'react';
import Button from '../../components/Button/Button';
import LogoWithText from '../../components/Navigation/Logo/LogoWithText';
import { login } from '../../services/auth/auth.service';
import styles from './Login.module.css';
import { useTranslation } from 'react-i18next';
import { useSTKContext } from '@/context/context';

const Login: FC = () => {
  const { t } = useTranslation();
  const {
    config: { loginUrl },
  } = useSTKContext();

  const loginCallback = useCallback(() => {
    login(loginUrl);
  }, [loginUrl]);

  return (
    <div className={styles.page}>
      <div className={styles.logoContainer}>
        <LogoWithText />
        <div className={styles.logoPattern} />
      </div>
      <div className={styles.buttonContainer}>
        <h1>{t('common.welcome')}</h1>
        <Button onClick={loginCallback}>{t('common.logIn')}</Button>
      </div>
    </div>
  );
};

export default Login;
